import React from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

function ProductSize({
  product,
  selectedSize,
  setSelectedSize,
  quantity,
  setQuantity,
}) {
  const handleSizeClick = (size) => {
    setSelectedSize(size);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  return (
    <>
    <div className="flex md:flex-row flex-col justify-center md:justify-start items-center md:items-center gap-2 py-2 w-full size-container">
     {product.options[1]?.name === 'Size' && <span className="font-secondaryFont tracking-widest">Size</span>}
      {
       product.options[0]?.name !== 'Color'  && <div className="flex justify-center items-center gap-2 capitalize size-btn-container">
             <span className="font-secondaryFont tracking-widest">{product.options[0]?.name}</span>

        {product.options[0]?.values.map((size, index) => (
          <button
            key={index}
            className={`border-[1px] hover:bg-black focus:bg-black active:bg-black border-black rounded-lg w-auto p-1 h-10 
            text-primary text-sm hover:text-white focus:text-white active:text-white
            ${selectedSize === size ? "bg-black text-white" : ""} `}
            onClick={() => handleSizeClick(size)}
          >
            {size}
          </button>
        ))}
      </div>
      }
      <div className="flex justify-center items-center gap-2 capitalize size-btn-container">
        {product.options[1]?.values.map((size, index) => (
          <button
            key={index}
            className={`border-[1px] hover:bg-black focus:bg-black active:bg-black border-black rounded-lg w-10 h-10 
            text-primary text-sm hover:text-white focus:text-white active:text-white
            ${selectedSize === size ? "bg-black text-white" : ""} `}
            onClick={() => handleSizeClick(size)}
          >
            {size}
          </button>
        ))}
      </div>
      </div>
      <div className="flex md:flex-row flex-col justify-center md:justify-start items-center md:items-center gap-2 w-full size-container">

      <span className="font-primaryFont tracking-widest">Quantity</span>
      <div className="relative flex justify-center items-center border quantity-container">
        <span
          className="hover:bg-black p-2 hover:text-white cursor-pointer"
          onClick={decreaseQuantity}
        >
          <AiOutlineMinus />
        </span>
        <input
          type="text"
          disabled
          min="1"
          value={quantity}
          className="bg-white w-5 text-center"
          onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value)))}
          placeholder="1"
        />
        <span
          className="hover:bg-black p-2 hover:text-white cursor-pointer"
          onClick={increaseQuantity}
        >
          <AiOutlinePlus />
        </span>
      </div>
    </div>
    </>
  );
}

export default ProductSize;
